import { useTranslations } from '@vocab/react';

import { getOptionText } from 'src/app/utils/getOptionText';
import { CajaWorkType } from 'src/types/cajaWorkType';

import translations from './.vocab';

export const useWorkTypeTaxonomy = () => {
  const { t } = useTranslations(translations);

  const workTypes = [
    {
      text: t('work-type-taxonomy-full-time'),
      value: CajaWorkType.FullTime,
    },
    {
      text: t('work-type-taxonomy-part-time'),
      value: CajaWorkType.PartTime,
    },
    {
      text: t('work-type-taxonomy-contract'),
      value: CajaWorkType.Contract,
    },
    {
      text: t('work-type-taxonomy-casual'),
      value: CajaWorkType.Casual,
    },
  ];

  const getWorkTypeText = (value: string) => getOptionText(workTypes, value);

  return { workTypes, getWorkTypeText };
};
